import { handleMap } from './_functions';
const { $ } = window;
//const $body = $( document.body )

export default {
	init() {
		
		$( '.wpcf7 select option:first-of-type' ).attr( 'disabled', true );
	},
	finalize() {
		
		setTimeout( () => {
			$( '.contact-location-map' ).each( ( _, el ) => {
				handleMap( el );
			} );
			console.log(document.querySelectorAll('.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl-attrib-inner a'))
			document.querySelectorAll('.mapboxgl-ctrl-bottom-right .mapboxgl-ctrl-attrib-inner a').forEach(el => {
				el.setAttribute('rel', 'nooopener noreferrer')
			})
		}, 1000);
	},
};

